const prod_handle = document
  .getElementById("product-handle")
  .getAttribute("data-url");
console.log(prod_handle);
let _view_history = localStorage.getItem("view_history")
  ? JSON.parse(localStorage.getItem("view_history"))
  : [];
if (_view_history && _view_history.length > 0) {
  var isHave = false;
  var _index = -1;
  for (const item of _view_history) {
    _index++;
    if (item.handle == prod_handle) {
      isHave = true;
      console.log("have ~~~");
      break;
    }
  }
  if (!isHave) {
    _view_history.push({ handle: prod_handle });
    localStorage.setItem("view_history", JSON.stringify(_view_history));
  } else {
    _view_history.splice(_index, 1);
    _view_history.push({ handle: prod_handle });
    localStorage.setItem("view_history", JSON.stringify(_view_history));
  }
} else {
  _view_history.push({ handle: prod_handle });
  localStorage.setItem("view_history", JSON.stringify(_view_history));
}
_view_history = _view_history.reverse();
console.log(_view_history);
const set_recent_view = async (list) => {
  let _recent_view_list = list;
  _recent_view_list.splice(0, 1);
  const _recent_viewed = document.getElementById("rv-list");
  let _html = "";
  let _nums = 0;
  if (list && list.length > 0) {
    for (const item of list) {
      if (_nums >= 6) {
        break;
      }
      const _prodInfo = await getProductByHandle(
        item.handle.replace("/products/", "")
      );
      if (_prodInfo) {
        const _template = createTemplate(
          _prodInfo,
          item.handle.replace("/products/", "")
        );
        _html += _template;
        _nums++;
      }
    }
    _recent_viewed.innerHTML = _html;
  } else {
    const _section_recent_viewed = document.getElementById(
      "section-recent-viewed"
    );
    _section_recent_viewed.style.display = "none";
  }
};
// 获取商品信息的函数
async function getProductByHandle(handle) {
  const query = `
              query($handle: String!) {
                productByHandle(handle: $handle) {
                  id
                  title
                  description
                  vendor
                  metafields(identifiers: [{namespace: "wk_custom_field", key: "cus_oiloncanvas"},{namespace: "wk_custom_field", key: "cus_size"},{namespace: "wk_custom_field", key: "cus_isquire"}]) {
                    key
                    value
                  }
                  variants(first: 5) {
                    edges {
                      node {
                        id
                        title
                        price {
                          amount
                          currencyCode
                        }
                        product {
                          id
                          featuredImage {
                            originalSrc
                            altText
                          }
                        }
                        sku
                      }
                    }
                  }
                }
              }
            `;

  const variables = {
    handle: handle,
  };

  return fetchGraphQL(query, variables)
    .then((data) => {
      const product = data.productByHandle;
      console.log(product);
      return product;
    })
    .catch((error) => {
      console.error("Error retrieving product:", error);
    });
}
function fetchGraphQL(query, variables = {}) {
  const endpoint =
    "https://store.magnifissance.com/api/2023-07/graphql.json";
  const accessToken = "6dd485b7997c77cc4794f50f5ff2ae3b"; // 替换为您的访问令牌

  return fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then((response) => response.json())
    .then((data) => data.data)
    .catch((error) => {
      console.error("GraphQL Error:", error);
    });
}
const createTemplate = (prod, prod_handle) => {
  console.log(prod);
  if (prod == null) {
    return "";
  }
  let _product_vendor = prod.vendor.replace(" ", "-").toLowerCase();
  let _ooc = "";
  let _size = "";
  let _isquire = "";
  if (prod.metafields && prod.metafields.length > 0) {
    for (const item of prod.metafields) {
      if (item && item.key && item.key == "cus_oiloncanvas") {
        _ooc = item.value;
      }
      if (item && item.key && item.key == "cus_size") {
        _size = item.value;
      }
      if (item && item.key && item.key == "cus_isquire") {
        _isquire = item.value;
      }
    }
  }
  let _price = "";
  if (_isquire != "Yes") {
    _price = "$ " + formatCurrency_v1(prod.variants.edges[0].node.price.amount);
  } else {
    _price = "Price upon request";
  }
  let _save = create_save_rv(prod.id, "/products/" + prod_handle);
  let _html = `<div class="rv-p-block">
        <a href="/products/${prod_handle}">
          <div class="img">
              <img src=${prod.variants.edges[0].node.product.featuredImage.originalSrc}">
          </div>
        </a>
        <div class="rv-p-info">
            ${_save}
            <div class="rv-b-vendor""><a href='/pages/artists/${_product_vendor}'>${prod.vendor}</a></div>
            <div><a href="/products/${prod_handle}" class="rv-b-title">${prod.title}</a></div>
            <div class="rvb-attr">${_ooc}</div>
            <div class="rvb-attr2">${_size}</div>
            <div class="price money">${_price}</div>
        </div>
      </div>
  `;
  return _html;
};

function formatCurrency_v1(num) {
  num = num.toString().replace(/\$|\,/g, "");
  if (isNaN(num)) num = "0";
  sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001);
  cents = num % 100;
  num = Math.floor(num / 100).toString();
  if (cents < 10) cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
    num =
      num.substring(0, num.length - (4 * i + 3)) +
      "," +
      num.substring(num.length - (4 * i + 3));
  return (sign ? "" : "-") + num;
}

var faqAccordion_ea = {
  init: function () {
    var flg = 0;
    var $faqHeading = $(".faqAccordion_ea > dt > button");
    $faqHeading.on("click activate", function () {
      if (flg) return false;
      flg = 1;
      var state = $(this).attr("aria-expanded") === "false" ? true : false;
      $(this).attr("aria-expanded", state);
      $(this)
        .parent()
        .next()
        .slideToggle(function () {
          flg = 0;
        });
      $(this).parent().next().attr("aria-hidden", !state);
      return false;
    });
    $faqHeading.on("keydown", function (event) {
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger("activate");
      }
    });
  },
  unload: function ($target) {
    $(".faqAccordion_ea > dt > button").off("click activate");
    $(".faqAccordion_ea > dt > button").off("keydown");
  },
};

//add zoom-in product image
const setZoomInBtn = () => {
  const _btn_zoom = document.querySelectorAll(".prod-img-zoom");
  _btn_zoom.forEach(function (currentBtn) {
    currentBtn.addEventListener("click", (handleEvent) => {
      const _img_url = currentBtn.querySelector("img").src;
      console.log(_img_url);
      openZoomDiv(_img_url);
    });
  });
};

const openZoomDiv = (img_url) => {
  //add zoom tools
  var wrapper_tools = document.createElement("div");
  wrapper_tools.id = "zoom-tools";
  var wrapper_minus = document.createElement("div");
  wrapper_minus.id = "zoom-minus";
  var wrapper_plus = document.createElement("div");
  wrapper_plus.id = "zoom-plus";
  var wrapper_input = document.createElement("input");
  wrapper_input.id = "slider-zoom";
  wrapper_input.type = "range";
  wrapper_input.step = "0.001";
  wrapper_tools.appendChild(wrapper_minus);
  wrapper_tools.appendChild(wrapper_input);
  wrapper_tools.appendChild(wrapper_plus);
  //add others
  var wrapper1 = document.createElement("div");
  var wrapper2 = document.createElement("div");
  var wrapper3 = document.createElement("div");
  var wrapper4 = document.createElement("div");
  var wrapper5 = document.createElement("div");
  wrapper2.classList.add("zoom-div");
  wrapper3.classList.add("zoom-block");
  wrapper4.id = "openseadragon-viewer";
  wrapper5.id = "zoom-btn-close";
  wrapper3.appendChild(wrapper5);
  wrapper3.appendChild(wrapper_tools);
  wrapper3.appendChild(wrapper4);
  wrapper2.appendChild(wrapper3);
  wrapper1.appendChild(wrapper2);
  const _body = document.querySelector("body");
  _body.classList.add("bodyHiddenScrool");
  _body.appendChild(wrapper1);
  wrapper5.addEventListener("click", (event) => {
    wrapper1.remove();
    _body.classList.remove("bodyHiddenScrool");
  });
  view_zoom_init(img_url);
};

const view_zoom_init = (img_url) => {
  var viewer = OpenSeadragon({
    id: "openseadragon-viewer",
    // toolbar: "zoom-tools",
    showNavigationControl: false,
    // showNavigator:  true,
    // zoomInButton: "zoom-plus",
    // zoomOutButton: "zoom-minus",
    // minZoomLevel: 0.6,
    maxZoomLevel: 4.3,
    visibilityRatio: 1.0,
    constrainDuringPan: true,
    tileSources: {
      type: "image",
      url: img_url,
      crossOriginPolicy: "Anonymous",
      ajaxWithCredentials: false,
    },
  });
  viewer.addHandler("zoom", function (event) {
    // 获取滚轮事件对象
    let _v = viewer.viewport.getZoom();
    input.value = _v;
  });

  let _min = viewer.viewport.getMinZoom();
  console.log(_min);
  let _max = viewer.viewport.getMaxZoom();
  console.log(_max);
  const input = document.querySelector("#slider-zoom");
  input.min = _min;
  input.max = _max;
  input.value = viewer.viewport.getHomeZoom();

  input.addEventListener("input", (event) => {
    viewer.viewport.zoomTo(input.value);
  });
  const _zoom_minus = document.querySelector("#zoom-minus");
  const _zoom_plus = document.querySelector("#zoom-plus");
  _zoom_plus.addEventListener("click", (event) => {
    let _v = parseFloat(input.value);
    console.log(input.value);
    _v = _v + 0.5;
    _v = _v > _max ? _max : _v;
    console.log(_v);
    viewer.viewport.zoomTo(_v);
    // input.setAttribute("value", _v);
    input.value = _v;
  });
  _zoom_minus.addEventListener("click", (event) => {
    let _v = parseFloat(input.value);
    console.log(_v);
    _v = _v - 0.5;
    _v = _v < _min ? _min : _v;
    console.log(_v);
    viewer.viewport.zoomTo(_v);
    input.value = _v;
  });
};

const setViewInRoom = () => {
  var sizeFieldset = document.querySelectorAll(".prod-select-variant");
  console.log(sizeFieldset.length);
  var viewInRoom = document.querySelector("#view-in-room");
  viewInRoom.addEventListener("click", (event) => {
    const sGallery = document.querySelector('[id^="Slider-Gallery"]');
    const imageLi = sGallery.querySelectorAll("li.is-active");
    const checkedRadio = document.querySelector(
      '.v_size input[type="radio"]:checked'
    );
    const imageType = checkedRadio.value;
    console.log(imageType);
    if (imageLi.length > 0) {
      // var _prod_img_list = document.querySelectorAll(".prod-img-zoom");
      var _img_url = imageLi[0].querySelector(".product__media img").src;
      var _img_size = 243.84;
      switch (imageType) {
        case "Medium":
          _img_size = 66;
          break;
        case "Large":
          _img_size = 96;
          break;
        case "Giant":
          _img_size = 112;
          break;
        case "Collector":
          _img_size = 142;
          break;
        case "Exhibition":
          _img_size = 168;
          break;
        default:
          _img_size = 66;
      }
      // var _img_url = _prod_img_list[0].getAttribute("data-url");
      // var _img_size = _prod_img_list[0].getAttribute("data-size");
      if (sizeFieldset && sizeFieldset.length > 0) {
        var _v = imageType;
        var startIndex = _v.indexOf("｜") + 1;
        var endIndex = _v.indexOf("cm");
        var extractedNumber = _v.substring(startIndex, endIndex).trim();
        extractedNumber = extractedNumber.split("x")[0];
        _img_size = extractedNumber;
        console.log("view in room size vv", extractedNumber);
        var _image_path = checkedRadio.getAttribute("data-image");
        _img_url = "https://easternaesthete.com/cdn/shop/" + _image_path;
      }

      console.log("view in room size", _img_url);
      openViewInRoomDiv(_img_url, _img_size);
    }
  });
};

const openViewInRoomDiv = (img_url, img_size) => {
  var wrapper1 = document.createElement("div");
  var wrapper2 = document.createElement("div");
  var wrapper3 = document.createElement("div");
  var wrapper4 = document.createElement("div");
  var wrapper5 = document.createElement("div");
  wrapper2.classList.add("zoom-div");
  wrapper3.classList.add("zoom-block");
  wrapper5.id = "zoom-btn-close";
  wrapper4.id = "zoom-bg-ec";
  var _image_frame = document.createElement("div");
  _image_frame.id = "image-frame";
  var _image = document.createElement("img");
  // _image.src = "https://easterncurator.myshopify.com/cdn/shop/" + img_url;
  _image.src = img_url;
  // var _w = (parseFloat(img_size) * 2000) / 543.2203389830508;
  var _w = (parseFloat(img_size) * 2000) / 592.56888888888889;
  _image.width = _w;
  _image_frame.appendChild(_image);
  wrapper4.appendChild(_image_frame);
  wrapper3.appendChild(wrapper5);
  wrapper3.appendChild(wrapper4);
  wrapper2.appendChild(wrapper3);
  wrapper1.appendChild(wrapper2);
  const _body = document.querySelector("body");
  _body.classList.add("bodyHiddenScrool");
  _body.appendChild(wrapper1);
  wrapper5.addEventListener("click", (event) => {
    wrapper1.remove();
    _body.classList.remove("bodyHiddenScrool");
  });
  //update ratio
  var t = 1;
  const _screen_w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const _screen_h =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  console.log(_screen_w);
  console.log(_screen_h);
  if (_screen_w >= 2000) {
    if (_screen_h < 1456) {
      t = _screen_h / 1456;
    }
  } else {
    t =
      _screen_w / _screen_h > 1.373626373626374
        ? _screen_h / 1456
        : _screen_w / 2000;
  }
  if (_screen_h >= 1456) {
    if (_screen_w < 2000) {
      t = _screen_w / 2000;
    }
  } else {
    t =
      _screen_w / _screen_h > 1.373626373626374
        ? _screen_h / 1456
        : _screen_w / 2000;
  }

  var te = 1031,
    ne = 693;
  wrapper4.style.transform = "scale(".concat(t, ")");
  window.addEventListener("resize", changeZoomTransfrom);
};

const changeZoomTransfrom = () => {
  var wrapper4 = document.querySelector("#zoom-bg-ec");
  var t = 1;
  const _screen_w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const _screen_h =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  console.log(_screen_w);
  console.log(_screen_h);
  if (_screen_w >= 2000) {
    if (_screen_h < 1456) {
      t = _screen_h / 1456;
    }
  } else {
    t =
      _screen_w / _screen_h > 1.373626373626374
        ? _screen_h / 1456
        : _screen_w / 2000;
  }
  if (_screen_h >= 1456) {
    if (_screen_w < 2000) {
      t = _screen_w / 2000;
    }
  } else {
    t =
      _screen_w / _screen_h > 1.373626373626374
        ? _screen_h / 1456
        : _screen_w / 2000;
  }
  wrapper4.style.transform = "scale(".concat(t, ")");
};

const create_save_rv = (id, url) => {
  let _id = id.replace("gid://shopify/Product/", "");
  return `
  <div class="add_f_btn" data-id="${_id}" data-url="${url}">
                <div class="inactive"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="圖層_1" x="0px" y="0px" viewBox="0 0 151.7 150" style="enable-background:new 0 0 151.7 150;" xml:space="preserve">
<style type="text/css">
	.st03={fill:none;stroke:currentColor;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<path class="st0" d="M32.3,10.7C18.6,13.4,7.6,24.4,4.6,38c-2.5,11.2,0.5,21.6,6.5,29.5h-0.2l59.3,69.2c2.9,3.4,8.1,3.4,10.9,0  l59.3-69.2h-0.1c6-8,9-18.3,6.5-29.5c-3-13.6-14-24.6-27.7-27.3C96,6.1,75.7,23.7,75.7,45.9C75.7,23.6,55.4,6.1,32.3,10.7z"></path>
</svg></div>
                <div class="active"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="圖層_1" x="0px" y="0px" viewBox="0 0 151.7 150" style="enable-background:new 0 0 151.7 150;" xml:space="preserve">
<style type="text/css">
	.st0s{stroke:#000000;stroke-miterlimit:10;}
</style>
<path class="st0s" d="M32.3,10.7C18.6,13.4,7.6,24.4,4.6,38c-2.5,11.2,0.5,21.6,6.5,29.5h-0.2l59.3,69.2c2.9,3.4,8.1,3.4,10.9,0  l59.3-69.2h-0.1c6-8,9-18.3,6.5-29.5c-3-13.6-14-24.6-27.7-27.3C96,6.1,75.7,23.7,75.7,45.9C75.7,23.6,55.4,6.1,32.3,10.7z"></path>
</svg></div>
              </div>
`;
};

const p_rv_main = async () => {
  await set_recent_view(_view_history);
  _btn_add_my_favorites = document.querySelectorAll(".add_f_btn");
  const _btn_add_my_favorites_rv = document.querySelectorAll(
    ".rv-prod-list .add_f_btn"
  );
  console.log("--->", _btn_add_my_favorites.length);
  _btn_add_my_favorites_rv.forEach(function (currentBtn) {
    currentBtn.addEventListener("click", (handleEvent) => {
      if (_login_user_) {
        console.log(currentBtn.getAttribute("data-id"));
        const _prod_handle = currentBtn
          .getAttribute("data-url")
          .replace("/products/", "");
        console.log(_prod_handle),
          update_favorites(_prod_handle),
          update_others_this_product_btn(_prod_handle);
      } else window.location.href = "/account/login";
    });
  });
  get_customer_favorites();
};

p_rv_main();

document.addEventListener("DOMContentLoaded", function async() {
  faqAccordion_ea.init();
  setZoomInBtn();
  setViewInRoom();
});
